import getLocalString from "constants/Localization";
import {
  useGetReportJobCostDetailMutation,
} from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportJobCostDetail = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportJobCostDetailMutation();

  const [getReportJobCostDetail, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportJobCostDetail",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportJobCostDetail, { ...context, data }] as const;
};

export default useGetReportJobCostDetail;
